import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reportingLeDataSessionPath } from '~/consts/reportingLeDataApi';

import { request } from '~/services/common';

import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

import { reportingLeDataSessionQueryKeys } from './useGetReportingLeDataSession';
import { reportingLeDataSharedSessionQueryKeys } from './useGetReportingLeDataSharedSession';
import { reportingLeDataSessionsQueryKeys } from './useRecentReportingLeDataSessions';

export function useDeleteReportingLeDataSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (sessionId: string) => {
      const url = resolveReportingLeDataUrl(reportingLeDataSessionPath(sessionId));
      await request(url, { method: 'DELETE' });
    },
    onSuccess: (_data, sessionId) => {
      void queryClient.invalidateQueries({ queryKey: reportingLeDataSessionsQueryKeys.all });
      void queryClient.removeQueries({ queryKey: reportingLeDataSessionQueryKeys.detail(sessionId) });
      void queryClient.removeQueries({ queryKey: reportingLeDataSharedSessionQueryKeys.detail(sessionId) });
    },
  });
}
